module.exports = __webpack_public_path__ + "static/media/Title_Multimedia_Download_es.11b84898.jpg";